import React, { useState, useEffect } from "react";
import i18n from "i18next";

import { fetchWrapper } from "../../helpers/fetchwrapper";

// Fluent UI Imports
import { baseUrl } from "../../helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";

interface IDeleteConfigurationDialogProps {
  guid: string;
  isDialogOpen: boolean;
  onDismiss: any;
  onDelete(): void;
}

function DeleteConfigurationDialog(props: IDeleteConfigurationDialogProps) {
  const DeleteConfiguration = () => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/configurator/DeleteConfiguration?guid=${props.guid}`,
      )
      .then((result: any) => {
        props.onDelete();
      });
  };

  return (
    <Dialog open={props.isDialogOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("deleteConfigDialog")}</DialogTitle>
          <DialogContent>
            {i18n.t<string>("deleteConfigDialogSubText")}
          </DialogContent>
          <DialogActions>
            <Button
              icon={<DeleteRegular />}
              appearance="primary"
              onClick={() => DeleteConfiguration()}
            >
              {i18n.t<string>("delete")}
            </Button>
            <Button
              onClick={() => {
                props.onDismiss(true);
              }}
            >
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
    /* <Dialog
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      hidden={!props.isDialogOpen}
      onDismiss={() => props.onDismiss()}
    >
      <DialogFooter>
        <PrimaryButton
          iconProps={{ iconName: "Delete" }}
          onClick={() => DeleteConfiguration()}
          text={i18n.t<string>("delete")}
        />
        <DefaultButton
          iconProps={{ iconName: "Cancel" }}
          onClick={() => {
            props.onDismiss(true);
          }}
          text={i18n.t<string>("cancel")}
        />
      </DialogFooter>
    </Dialog> */
  );
}

export default DeleteConfigurationDialog;
